const Options = [
  {
    text: 'Community education within an organization or association',
  },
  {
    text: 'Educating users or customers about a digital product',
  },
  {
    text: 'Training employees as an internal expert (e.g., L&D, HR)',
  },
  {
    text: 'Training employees as an external contractor',
  },
  {
    text: 'Selling mini-courses directly to individuals',
  },
  {
    text: 'Other / Not sure',
  },
]

export { Options }
